module.exports = __webpack_public_path__ + "static/media/Appeal_ICON.d3482770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/drivers/Appeal_ICON.svg
// module id = 1605
// module chunks = 0